module.exports = __webpack_public_path__ + "img/404.3266b8f9.png";